import React, { Fragment, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"

import { deliverStockTransferRequest } from "services"
import { validateStockTransferContents } from "utils"
import { Button, OrderStockValidationResultModal } from "components"
import classes from "./StrdrmFooter.module.scss"

const StrdrmFooter = (props) => {
  const {
    acceptedItems,
    stockTransferRequest,
    setStockTransferRequests,
    setOpenDeliverConfirmationModal
  } = props

  const [sending, setSending] = useState(false)
  const [problematicItems, setProblematicItems] = useState([])
  const [openOrderValidationResultModal, setOpenOrderValidationResultModal] = useState(false)

  const unmount = useRef(false)

  const validateRequestItems = async () => {
    const filteredRequestedItem =
      acceptedItems.filter(requestedItem =>
        requestedItem.acceptedQuantity !== 0
      )

    const problematicItems =
      await validateStockTransferContents(
        filteredRequestedItem,
        stockTransferRequest.sourceBranchId
      )

    if (problematicItems.length === 0) return true

    setProblematicItems(
      problematicItems
    )

    setOpenOrderValidationResultModal(true)

    return false
  }


  const handleDeliverStockTransfer = async () => {
    setSending(true)

    const result =
      await validateRequestItems()

    if (!result) return setSending(false)

    try {
      const response =
        await deliverStockTransferRequest(
          stockTransferRequest._id
        )

      if (unmount.current) return

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === stockTransferRequest._id
            ? { ...str, ...response }
            : str
        )
      )

      setOpenDeliverConfirmationModal(false)

      toast.success("محموله ارسال شد")
    } catch (err) {
      console.log(err)

      toast.error("عملیات انجام نشد")

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <div className={classes["footer"]}>
        <Button
          loading={sending}
          onClick={handleDeliverStockTransfer}
          color="success"
        >
          ارسال محموله
        </Button>
      </div>
      <OrderStockValidationResultModal
        problematicItems={problematicItems}
        openOrderValidationResultModal={openOrderValidationResultModal}
        setOpenOrderValidationResultModal={setOpenOrderValidationResultModal}
      />
    </Fragment>
  )
}

export default StrdrmFooter